// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2T5Xd","largestCol":"styles_largestCol__1c_ar","smallestCol":"styles_smallestCol__3OfWr"};